import * as React from "react";
import {Component} from "react";
import styles from "../../styles/flyouts/storeys/Properties.scss";
import * as _ from "lodash";
import {withRouter} from "react-router";
import autobind from "autobind-decorator";
import {__, validateForm} from "../../core/utils";
import {setNotification} from "../../redux/actions/general/notification";
import {listStoreys, updateStorey} from "../../redux/actions/table/storeys";
import EditStoreyForm from "../../forms/storeys/EditStoreyForm";

@withRouter
class Properties extends Component {
    @autobind
    _handleSubmit(formData) {
        return validateForm(
            updateStorey(formData.id, _.omit(formData, ['id'])).then(() => {
                listStoreys(this.props.match.params.stage);

                this.props.readAction(formData.id);

                setNotification(__('storeys.flyout.notification.saved'));
            })
        );
    }

    render() {
        const {data} = this.props;

        return (
            <div className={styles.scroller}>
                <EditStoreyForm
                    onSubmit={this._handleSubmit}
                    data={data}
                    initialValues={{
                        ..._.pick(data, ['id', 'building_id', 'number', 'name', 'description', 'relative_altitude', 'height', 'volume', 'area']),
                        outside: _.toString(data.outside),
                    }}
                />
            </div>
        );
    }
}

export default Properties;
